'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmailHash = exports.fetchingCustomerPrefs = exports.contactPrefs = exports.passwordResetHashValid = exports.newPasswordHasBeenSet = exports.passwordHasBeenReset = exports.passwordResetHashError = exports.thirdpartyVerifyError = exports.newPasswordError = exports.passwordResetError = exports.updatingPasswordError = exports.loginError = exports.loginResult = exports.loginAttempts = exports.isVerifying = exports.isRequestingNewPassword = exports.isRequestingPasswordReset = exports.isUpdatingPassword = exports.isLoggingIn = exports.isVerified = exports.isLoggedIn = exports.hasValidRefreshToken = exports.hasValidToken = exports.getStaffId = exports.getTokenExpiry = exports.getAccessToken = exports.getClientId = exports.getRefreshToken = exports.getGuid = exports.getCreditBrokerStatus = exports.getUserScope = exports.getUsername = exports.getUser = exports.getAuth = undefined;
var _constants = require('./constants');
var getAuth = exports.getAuth = function getAuth(state) {
  return state[_constants.NAME].auth;
};
var getUser = exports.getUser = function getUser(state) {
  return state[_constants.NAME].user;
};
var getUsername = exports.getUsername = function getUsername(state) {
  return state[_constants.NAME].user.name;
};
var getUserScope = exports.getUserScope = function getUserScope(state) {
  return state[_constants.NAME].user.scope;
};
var getCreditBrokerStatus = exports.getCreditBrokerStatus = function getCreditBrokerStatus(state) {
  var user = getUser(state);
  return {
    ldiCreditBroker: user.isLdiCreditBroker,
    ndiCreditBroker: user.isNdiCreditBroker
  };
};
var getGuid = exports.getGuid = function getGuid(state) {
  return getUser(state).guid;
};
var getRefreshToken = exports.getRefreshToken = function getRefreshToken(state) {
  return state[_constants.NAME].auth.refreshToken;
};
var getClientId = exports.getClientId = function getClientId(state) {
  return state[_constants.NAME].auth.clientId;
};
var getAccessToken = exports.getAccessToken = function getAccessToken(state) {
  return state[_constants.NAME].auth.token;
};
var getTokenExpiry = exports.getTokenExpiry = function getTokenExpiry(state) {
  return state[_constants.NAME].auth.expires;
};
var getStaffId = exports.getStaffId = function getStaffId(state) {
  return state[_constants.NAME].staffId || (getUser(state) ? getUser(state).rbacUserId : undefined);
};
var hasValidToken = exports.hasValidToken = function hasValidToken(state) {
  return state[_constants.NAME].auth.expires && Date.now() < state[_constants.NAME].auth.expires;
};

// Old export name. Kept for backward compatibility.
var hasValidRefreshToken = exports.hasValidRefreshToken = hasValidToken;
var isLoggedIn = exports.isLoggedIn = function isLoggedIn(state) {
  if (state[_constants.NAME].auth.refreshToken) return true;
  return false;
};
var isVerified = exports.isVerified = function isVerified(state) {
  return state[_constants.NAME].thirdpartyVerified;
};

// REQUEST LIFECYCLE

// Pending
var isLoggingIn = exports.isLoggingIn = function isLoggingIn(state) {
  return state[_constants.NAME].loggingIn;
};
var isUpdatingPassword = exports.isUpdatingPassword = function isUpdatingPassword(state) {
  return state[_constants.NAME].updatingPassword;
};
var isRequestingPasswordReset = exports.isRequestingPasswordReset = function isRequestingPasswordReset(state) {
  return state[_constants.NAME].requestingPasswordReset;
};
var isRequestingNewPassword = exports.isRequestingNewPassword = function isRequestingNewPassword(state) {
  return state[_constants.NAME].isRequestingNewPassword;
};
var isVerifying = exports.isVerifying = function isVerifying(state) {
  return state[_constants.NAME].verifyingThirdparty;
};
var loginAttempts = exports.loginAttempts = function loginAttempts(state) {
  return state[_constants.NAME].loginAttempts;
};
var loginResult = exports.loginResult = function loginResult(state) {
  return state[_constants.NAME].loginResult;
};

// Rejected
var loginError = exports.loginError = function loginError(state) {
  return state[_constants.NAME].loginError;
};
var updatingPasswordError = exports.updatingPasswordError = function updatingPasswordError(state) {
  return state[_constants.NAME].updatingPasswordError;
};
var passwordResetError = exports.passwordResetError = function passwordResetError(state) {
  return state[_constants.NAME].passwordResetError;
};
var newPasswordError = exports.newPasswordError = function newPasswordError(state) {
  return state[_constants.NAME].newPasswordError;
};
var thirdpartyVerifyError = exports.thirdpartyVerifyError = function thirdpartyVerifyError(state) {
  return state[_constants.NAME].thirdpartyVerifyError;
};
var passwordResetHashError = exports.passwordResetHashError = function passwordResetHashError(state) {
  return state[_constants.NAME].passwordResetHashError;
};

// Fulfilled
var passwordHasBeenReset = exports.passwordHasBeenReset = function passwordHasBeenReset(state) {
  return state[_constants.NAME].passwordHasBeenReset;
};
var newPasswordHasBeenSet = exports.newPasswordHasBeenSet = function newPasswordHasBeenSet(state) {
  return state[_constants.NAME].newPasswordHasBeenSet;
};
var passwordResetHashValid = exports.passwordResetHashValid = function passwordResetHashValid(state) {
  return state[_constants.NAME].passwordResetHashValid;
};

// Customer prefs
var contactPrefs = exports.contactPrefs = function contactPrefs(state) {
  return state[_constants.NAME].contactPrefs;
};
var fetchingCustomerPrefs = exports.fetchingCustomerPrefs = function fetchingCustomerPrefs(state, formId) {
  return contactPrefs(state).fetching[formId];
};

// for dataLayer
var getEmailHash = exports.getEmailHash = function getEmailHash(state) {
  return state[_constants.NAME].emailHash;
};